export type Translations = Record<string, string>;

export function mergeTranslations(...parts: Translations[]): Translations {
  return parts.reduce<Translations>((merged, part) => {
    Object.keys(part).forEach((key) => {
      if (Object.prototype.hasOwnProperty.call(merged, key)) {
        throw new Error(`Duplicate translation key: ${key}`);
      }
      merged[key] = part[key];
    });
    return merged;
  }, {});
}
